import {
  CellClickedEvent,
  ColDef,
  GridOptions,
  GridReadyEvent,
  RowDataUpdatedEvent,
  RowGroupOpenedEvent,
  RowHeightParams,
} from "ag-grid-community";

import { RoundedDataGrid } from "./DataGrid";

export type TabularDataProps = {
  colDefs: ColDef[];
  rowData: Record<string, unknown>[];
  onGridReady?: (gridReadyEvent: GridReadyEvent) => void;
  onRowGroupOpened?: (event: RowGroupOpenedEvent) => void;
  event?: RowGroupOpenedEvent;
  height?: string | number;
  masterDetail?: boolean;
  popupParent?: HTMLElement | undefined;
  metadata?: any;
  onCellClicked?: (event: CellClickedEvent) => void;
  onRowDataUpdated?: (params: RowDataUpdatedEvent) => void;
  getRowHeight?: (params: RowHeightParams) => number | undefined;
};

export const TabularData: React.FC<TabularDataProps & GridOptions> = ({
  colDefs,
  rowData,
  onCellClicked,
  onGridReady,
  onRowGroupOpened,
  masterDetail = false,
  defaultColDef,
  metadata,
  onRowDataUpdated,
  ...props
}) => {
  return (
    <>
      <RoundedDataGrid
        height="100%"
        rowData={rowData}
        columnDefs={colDefs}
        onCellClicked={onCellClicked}
        defaultColDef={{
          ...defaultColDef,
          resizable: true,
          sortable: true,
          enableRowGroup: false,
        }}
        rowSelection="single"
        onGridReady={onGridReady}
        getRowId={(row: any) => row.data.__row_id}
        enableCellChangeFlash
        onRowGroupOpened={onRowGroupOpened}
        masterDetail={masterDetail}
        onRowDataUpdated={onRowDataUpdated}
        popupParent={props.popupParent}
        getRowHeight={props.getRowHeight}
        context={{
          metadata,
        }}
        {...props}
      />
    </>
  );
};
